<template>
    <div class="l-white">
        <div class="container-md">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <div class="py-6 px-2 px-sm-0">
                        <div class="row">
                            <div class="col-sm-5 pb-6 pb-sm-0 text-center">
                                <img class="img-fluid" alt="" src="/images/lejaan-bag.png"/>
                            </div>
                            <div class="col-sm-7 col-md-6 col-lg-5 text-center text-sm-left pt-sm-5">
                                <p>
                                    {{$t('components.BasketEmpty.text1')}}
                                </p>
                                <p class="mb-4">
                                    {{$t('components.BasketEmpty.text2')}}
                                </p>
                                <a class="btn btn--cta btn--big text-nowrap" @click.prevent="backToStore" href="#">
                                    <svg class="ico ico--medium">
                                        <use xlink:href="#cart"/>
                                    </svg>
                                    <span>{{$t('components.BasketEmpty.backToEshop')}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            backToStore: function() {
                this.$store.dispatch("backToStore", {});
            }
        }
    };
</script>
